/* NEON PALM — small behaviours. No dependencies. */
(function () {
  function init() {
    document.querySelectorAll('[data-np-header]').forEach(function (header) {
      var btn = header.querySelector('[data-np-toggle]');
      if (!btn || btn.dataset.bound || header.dataset.boundMenu) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var open = header.hasAttribute('data-open');
        if (open) header.removeAttribute('data-open'); else header.setAttribute('data-open', '');
        btn.setAttribute('aria-expanded', String(!open));
      });
    });

    document.querySelectorAll('[data-np-product]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var main = root.querySelector('[data-np-gallery-main]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-np-thumb]'));
      var current = 0;
      function show(n) {
        if (!thumbs.length || !main) return;
        current = (n + thumbs.length) % thumbs.length;
        var thumb = thumbs[current], img = thumb.querySelector('img');
        if (!img) return;
        main.removeAttribute('srcset'); main.removeAttribute('sizes');
        main.src = img.dataset.full || img.src; main.alt = img.alt;
        thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
        if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function (e) { e.preventDefault(); show(i); }); });
      var mainWrap = main ? main.parentElement : null;
      if (mainWrap && thumbs.length > 1 && !mainWrap.querySelector('[data-np-prev]')) {
        var prev = document.createElement('button'), next = document.createElement('button');
        prev.type = next.type = 'button';
        prev.className = 'np-gallery__arrow np-gallery__arrow--prev'; next.className = 'np-gallery__arrow np-gallery__arrow--next';
        prev.setAttribute('data-np-prev', ''); next.setAttribute('data-np-next', '');
        prev.setAttribute('aria-label', 'Previous image'); next.setAttribute('aria-label', 'Next image');
        prev.innerHTML = '&larr;'; next.innerHTML = '&rarr;';
        mainWrap.appendChild(prev); mainWrap.appendChild(next);
        prev.addEventListener('click', function () { show(current - 1); });
        next.addEventListener('click', function () { show(current + 1); });
        mainWrap.setAttribute('tabindex', '0');
        mainWrap.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') show(current - 1); if (e.key === 'ArrowRight') show(current + 1); });
        var sx = null;
        mainWrap.addEventListener('pointerdown', function (e) { sx = e.clientX; });
        mainWrap.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 40) show(dx < 0 ? current + 1 : current - 1); });
      }
      var row = root.querySelector('.np-gallery__thumbs');
      if (row && !row.dataset.drag) {
        row.dataset.drag = '1';
        var down = false, startX = 0, startL = 0, moved = false;
        row.addEventListener('mousedown', function (e) { down = true; moved = false; startX = e.pageX; startL = row.scrollLeft; });
        window.addEventListener('mouseup', function () { down = false; });
        row.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - startX; if (Math.abs(dx) > 3) moved = true; row.scrollLeft = startL - dx; });
        row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
        row.addEventListener('wheel', function (e) { if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { row.scrollLeft += e.deltaY; e.preventDefault(); } }, { passive: false });
      }

      var variantsEl = root.querySelector('[data-np-variants]');
      if (!variantsEl) return;
      var variants = JSON.parse(variantsEl.textContent);
      var idInput = root.querySelector('[data-np-variant-id]');
      var priceEl = root.querySelector('[data-np-price]');
      var addBtn = root.querySelector('[data-np-add]');
      var addLabel = addBtn ? addBtn.dataset.label : '';
      var soldLabel = addBtn ? addBtn.dataset.soldout : 'Sold out';
      var notify = root.querySelector('[data-np-notify]');
      var notifyTag = root.querySelector('[data-np-notify-tag]');
      var notifyNote = root.querySelector('[data-np-notify-note]');
      var express = root.querySelector('.np-buy__express');
      var money = function (cents) {
        var fmt = variantsEl.dataset.money || '${{amount}}';
        var amount = (cents / 100).toFixed(2);
        return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
      };
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-np-option]'));
      var update = function () {
        var picked = groups.map(function (group) { var c = group.querySelector('input:checked'); return c ? c.value : null; });
        groups.forEach(function (group, gi) {
          group.querySelectorAll('input').forEach(function (inp) {
            var ok = variants.some(function (v) {
              if (!v.available) return false;
              if (v.options[gi] !== inp.value) return false;
              return picked.every(function (val, i) { return i === gi || val === null || v.options[i] === val; });
            });
            var label = inp.closest('.np-swatch');
            if (label) label.classList.toggle('is-soldout', !ok);
          });
        });
        var match = variants.find(function (v) { return picked.every(function (val, i) { return val === null || v.options[i] === val; }); });
        if (!match) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; } return; }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (addBtn) { addBtn.disabled = !match.available; addBtn.textContent = match.available ? addLabel : soldLabel; }
        if (notify) {
          if (!notify.hasAttribute('data-np-posted')) notify.hidden = match.available;
          var vt = match.title || picked.join(' / ');
          if (notifyTag) notifyTag.value = 'back-in-stock, ' + vt;
          if (notifyNote) notifyNote.value = 'Back in stock request: ' + vt + ' (' + new Date().toISOString().slice(0, 10) + ')';
        }
        if (express) express.style.display = match.available ? '' : 'none';
        var hint = root.querySelector('[data-np-length-hint]');
        var lengthIdx = parseInt(root.dataset.lengthIndex, 10);
        if (hint && !isNaN(lengthIdx) && picked[lengthIdx]) {
          var hints = JSON.parse(hint.dataset.hints || '{}');
          hint.textContent = hints[picked[lengthIdx]] || '';
        }
      };
      root.querySelectorAll('[data-np-option] input').forEach(function (i) { i.addEventListener('change', update); });
      try {
        var params = new URLSearchParams(window.location.search);
        groups.forEach(function (group) {
          var legend = group.querySelector('legend');
          var name = legend ? legend.textContent.trim().toLowerCase() : '';
          var want = params.get(name);
          if (!want) return;
          want = want.toLowerCase();
          var inputs = group.querySelectorAll('input');
          for (var k = 0; k < inputs.length; k++) { if (inputs[k].value.toLowerCase().indexOf(want) === 0) { inputs[k].checked = true; break; } }
        });
      } catch (e) {}
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('page:loaded', init);
})();
